/**
 * What the sign-in screen says when a sign-in attempt fails.
 *
 * `POST /api/auth/login` is rate-limited (slowapi, 10 per minute per address).
 * When it trips, slowapi answers **429** with `{"error": "Rate limit exceeded:
 * 10 per 1 minute"}` — an `error` key, not FastAPI's `detail` — so a page that
 * reads only `detail` fell through to "Login failed. Please check your
 * credentials." and sent the person off to re-type a password that was fine.
 */
export const RATE_LIMITED_MESSAGE = 'Too many sign-in attempts — wait a minute and try again.';

export function signInErrorMessage(err, fallback) {
  if (err?.response?.status === 429) return RATE_LIMITED_MESSAGE;
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  return fallback;
}
